export default __webpack_public_path__ + "static/media/01.26b12a65.png";